module.exports = __webpack_public_path__ + "img/图层11.cd6093c3.png";